export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_q02_b.4d0d59c1.png";